export const arraysEqual = (a: number[], b: number[]): boolean => {
	return a.length === b.length && a.every((val) => b.includes(val)) && b.every((val) => a.includes(val));
};
